<style lang="css">

</style>

<template lang="html">

<div>
    <el-button type="primary" @click="$router.push({name:'添加车展商品', params: { businessId: searchInfo.businessId }})">上架新商品</el-button>

    <list-template ref="list-template" :queryParams="searchInfo" actionUrl="carShow/business/findBusinessProduct.action">
        <template slot="item" scope="scope">
            <el-card class="basic-margin" v-for="data in scope.datas">
              <el-row>
                <el-col :span="2">
                  <img :src="imageUrl+data.image" style="width:80px;height:80px;"></img>
                </el-col>
                <el-col :span="18">
                  <h4><b>{{data.name}}</b></h4>
                  <div style="color:#999">{{data.describes}}</div>
                  <div style="color:#999">{{data.createTime | dateTimeFormat}}</div>
                </el-col>
                <el-col :span="3">
                  <el-button v-confirm :confirm-data="data" @onConfirm="up" confirm-text="确定顶置?" type="text">顶置</el-button>
                  <el-button @click="$router.push({name:'保存车展商品', params: { id: data.id }})" type="text">修改</el-button>
                  <el-button v-confirm :confirm-data="data" @onConfirm="deleteProduct" confirm-text="确定删除?" type="text">删除</el-button>
                </el-col>
              </el-row>

            </el-card>
        </template>
    </list-template>
</div>

</template>

<script>

import CarExhibitionModel from '@/framework/models/CarExhibitionModel'
import ListTemplate from '@/components/ListTemplate'
import Config from '@/framework/configs/Config'
export default {
  components: {
    ListTemplate
  },
  data: function () {
    return {
      searchInfo: {
        businessId: null
      },
      imageUrl: Config.imageUrl,
      businessId: null
    }
  },
  created: function () {
    this.searchInfo.businessId = this.$route.params.businessId
  },
  methods: {
    up: function (data) {
      let _this = this
      let params = {
        productId: data.id
      }

      let listener = {
        success: function (dataInfo) {
          _this.$refs['list-template'].search()
          _this.$message.success('顶置成功！')
        }
      }
      CarExhibitionModel.upProduct(_this, params, listener)
    },
    deleteProduct: function (data) {
      let _this = this
      let params = {
        productId: data.id
      }

      let listener = {
        success: function (dataInfo) {
          _this.$refs['list-template'].search()
          _this.$message.success('删除成功！')
        }
      }
      CarExhibitionModel.deleteProduct(_this, params, listener)
    }
  }
}

</script>
